import {request} from '@/helpers/apiClient'
import {PRODUCTS_CONFIG} from '@/utils/constants/apiConfig/productsConfig'

export const getProductList = async () => {
  return request(PRODUCTS_CONFIG.PRODUCT_LIST)
}

export const getProductListColConfig = async () => {
  return request(PRODUCTS_CONFIG.PRODUCT_LIST_COL_CONFIG)
}
